export const PLATFORM_OPTIONS = [
  { value: 'facebook',   label: 'Facebook',    icon: '📘' },
  { value: 'instagram',  label: 'Instagram',   icon: '📸' },
  { value: 'twitter',    label: 'Twitter / X', icon: '🐦' },
  { value: 'linkedin',   label: 'LinkedIn',    icon: '💼' },
  { value: 'youtube',    label: 'YouTube',     icon: '▶️' },
  { value: 'tiktok',     label: 'TikTok',      icon: '🎵' },
  { value: 'whatsapp',   label: 'WhatsApp',    icon: '💬' },
  { value: 'telegram',   label: 'Telegram',    icon: '✈️' },
  { value: 'other',      label: 'Other',       icon: '🔗' },
];

export const getPlatformLabel = (value) =>
  PLATFORM_OPTIONS.find((o) => o.value === value)?.label ?? value;

export const getPlatformIcon = (value) =>
  PLATFORM_OPTIONS.find((o) => o.value === value)?.icon ?? '🔗';